import { get } from "../common/apiClient";

const getLeaderboardByExamType = async (params = {}) => {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      searchParams.append(key, value);
    }
  });

  const queryString = searchParams.toString();
  return await get(`/exam-result/leaderboard/by-type${queryString ? `?${queryString}` : ""}`);
};

const getLeaderboardExamTypes = async () => {
  return await get("/exam-result/leaderboard/exam-types");
};

export { getLeaderboardByExamType, getLeaderboardExamTypes };
